import React from "react";

import useStaticTableFilter, { StaticTableFilterHook } from "commons/hooks/useStaticTableFilter";

import { FilterFieldCollection } from "commons/types/table";

import storage from "commons/utils/storage";

function useStaticTableFilterWithMemory(
    key: string,
    fields: FilterFieldCollection
): StaticTableFilterHook {
    const getKey = React.useCallback(() => `static-table-filter-saved-${key}`, [key]);

    const initialFormValues = React.useMemo(() => storage.get(getKey()), [getKey]);

    const staticTableFilterHook = useStaticTableFilter(fields, initialFormValues);

    React.useEffect(() => {
        storage.set(getKey(), staticTableFilterHook.form);
    }, [getKey, staticTableFilterHook.form]);

    return staticTableFilterHook;
}

export default useStaticTableFilterWithMemory;
